import ReactDOM from "react-dom"
import App from "./App"
import {BrowserRouter} from 'react-router-dom'
import React from "react"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
)
